<template>
  <v-container grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm6 lg4>
        <v-card>
          <v-card-media
            src="static/img/clouds.jpg"
            height="200px">
            <v-container fill-height fluid>
              <v-layout fill-height>
                <v-flex xs12 align-end flexbox>
                  <span class="headline white--text" v-text="$t('admin.alerts.alerts')"></span>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-media>
          <v-card-text>
            Hello
          </v-card-text>
          <v-card-actions class="white">
            <v-spacer></v-spacer>
            <v-btn @click="$router.push('/admin/alerts')" icon>
              <v-icon>edit</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 lg4>
        <v-card>
          <v-card-media
            src="static/img/clouds.jpg"
            height="200px">
            <v-container fill-height fluid>
              <v-layout fill-height>
                <v-flex xs12 align-end flexbox>
                  <span class="headline white--text" v-text="$t('announcements.admin.title')"></span>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-media>
          <v-card-text>
            Announcements can be edited here
          </v-card-text>
          <v-card-actions class="white">
            <v-spacer></v-spacer>
            <v-btn @click="$router.push('/admin/announcements')" icon>
              <v-icon>edit</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import AlertsPage from './alert/AlertsPage'

  export default {
    components: {AlertsPage},
    name: 'admin-page'
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/settings/AdminPage.vue